var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.25,
    stroke: "#5E5E5E",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16.7778C11 14.0541 11 12.6923 11.8461 11.8461C12.6923 11 14.0541 11 16.7778 11H18.2222C20.9459 11 22.3078 11 23.1538 11.8461C24 12.6923 24 14.0541 24 16.7778V18.2222C24 20.9459 24 22.3078 23.1538 23.1538C22.3078 24 20.9459 24 18.2222 24H16.7778C14.0541 24 12.6923 24 11.8461 23.1538C11 22.3078 11 20.9459 11 18.2222V16.7778ZM21.8333 14.25C21.8333 14.8483 21.3483 15.3333 20.75 15.3333C20.1517 15.3333 19.6667 14.8483 19.6667 14.25C19.6667 13.6517 20.1517 13.1667 20.75 13.1667C21.3483 13.1667 21.8333 13.6517 21.8333 14.25ZM18.9444 18.2222C18.9444 19.02 18.2978 19.6667 17.5 19.6667C16.7022 19.6667 16.0556 19.02 16.0556 18.2222C16.0556 17.4245 16.7022 16.7778 17.5 16.7778C18.2978 16.7778 18.9444 17.4245 18.9444 18.2222ZM20.3889 18.2222C20.3889 19.8177 19.0955 21.1111 17.5 21.1111C15.9045 21.1111 14.6111 19.8177 14.6111 18.2222C14.6111 16.6268 15.9045 15.3333 17.5 15.3333C19.0955 15.3333 20.3889 16.6268 20.3889 18.2222Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramIcon);
export default __webpack_public_path__ + "static/media/instagram_icon.602a4d1067bc78317b7b2512555a2c5e.svg";
export { ForwardRef as ReactComponent };